<template>
    
    <div>

        <!-- Call to action-->
        <section class="page-section text-white masthead-3" style="background-color:#151117">
            <div class="container text-center">
                <div class="row justify-content-center">
                    <div class="col-lg-8 text-center">
                        <h2 class="mb-4">Follow the Music!</h2>
                        <a target="_blank" href="https://soundcloud.com/itstheraj">
                            <img class="p-2" src="img/soundcloud.svg" height="50px" />
                        </a>
                        <a target="_blank"  href="https://open.spotify.com/album/5rwcVlundf8QRkX1o185sV">
                            <img class="p-2" src="img/spotify.svg" height="50px" />
                        </a>
                        <a target="_blank"  href="https://www.youtube.com/channel/UCJ8bVjjr2e1PB0m5gXjSwLg?view_as=subscriber">
                            <img class="p-2" src="img/yt.png" height="50px" />
                        </a>
                        <a target="_blank"  href="https://www.instagram.com/rajmaitra/">
                            <img class="p-2" src="img/ig.png" height="50px" />
                        </a>
                    </div>
                </div>
                <div class="row justify-content-center" style="margin-top:30px">
                    <div class="col-lg-8 text-center">
                        <h2 class="mt-0">Contact</h2>
                    </div>
                </div>
                <div class="row mt-2 justify-content-center">
                    <div class="col-lg-6 col-sm-12 text-center">
                        <div class="bold color-red">
                            Instragram
                        </div>
                        <a class="text-white" target="_blank"  href="https://www.instagram.com/rajmaitra/">
                            @rajmaitra
                        </a>
                    </div>
                    <div class="col-lg-6 col-sm-12 text-center">
                        <div class="bold color-red">Email</div>
                        <a class="d-block text-white" href="mailto:info@loonaticproductions.com">info@loonaticproductions.com</a>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
export default {
  name: "Footer",
  computed: {
      isHome() {
         return this.$route.name === 'home'
     },
     isNotHome() {
        return this.$route.name !== 'home'
     }
    }
}
</script>

<style scoped>
</style>